import { addFilter } from "@wordpress/hooks";

const blockMap = {
  "core/heading": ["buildable/accordion"],
  "core/list": ["buildable/accordion"],
  "core/paragraph": ["buildable/accordion"]
}

addFilter(
  "blocks.registerBlockType",
  "buildable/filterCoreParents",
  (settings, name) => {
    if (Object.keys(blockMap).indexOf(name) > -1) {
      settings.parent = blockMap[name];
    } else if (
      name !== "woocommerce/product-category" &&
      name !== "woocommerce/all-products" &&
      name.indexOf("buildable/") === -1
    ) {
      settings.parent = [
        "buildable/dummy"
      ];
    }
    return settings;
  }
);
